module.exports = __webpack_public_path__ + "media/assets/images/flags/cn-5b69815a3c3a5c0f94fb83ec8aecf84f.svg";